import React from 'react'
import { Fa500Px, FaTruckLoading, FaUpload } from 'react-icons/fa'
import './Css/Loading.css'

export default function Loading() {
  return (
    <div className='universalbox backgroundimage'
    style={{
        
    }} 
    >
    <img className='loadingimage' src="./img/loading.gif" alt="loading"></img>
    </div>
  )
}
